import { useEffect, useState } from 'react'
import api from '../../../helpers/apiRequester'

/**
 * Is the signed-in user a Sentinel admin (Cognito `custom:admin` or the
 * dashboardUsers admin flag)? Resolved once per page load via
 * `/users-page-auth`, which 403s everyone else. Used to keep admin-only
 * omnibus UI (data tools, source breakdown, document links) out of the
 * page for monitoring users; the backend enforces the same rule.
 */
let cached: Promise<boolean> | null = null

const resolveIsAdmin = () => {
    if (!cached) {
        cached = api('/users-page-auth')
            .then(({ data }) => data?.isAdmin === true)
            .catch(() => false)
    }
    return cached
}

export const useIsAdmin = () => {
    const [isAdmin, setIsAdmin] = useState(false)
    useEffect(() => {
        let active = true
        resolveIsAdmin().then((value) => {
            if (active) setIsAdmin(value)
        })
        return () => {
            active = false
        }
    }, [])
    return isAdmin
}
